import React from "react";
import { Shield, CheckCircle, Clock, Phone } from "lucide-react";
import { motion } from "framer-motion";

const guaranteeFeatures = [
  {
    icon: Shield,
    title: "100% Risk-Free",
    description: "Try Zylu for 14 days with absolutely no risk",
  },
  {
    icon: CheckCircle,
    title: "No Questions Asked",
    description: "If you're not satisfied, we'll refund every penny",
  },
  {
    icon: Clock,
    title: "Quick Refund Process",
    description: "Get your money back within 2-3 business days",
  },
  {
    icon: Phone,
    title: "Dedicated Support",
    description: "Our team ensures your success every step of the way",
  },
];

const MoneyBackGuarantee: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="bg-red-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8">
            <Shield className="h-12 w-12 text-red-600" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            14-Day Money Back Guarantee
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're so confident Zylu will transform your salon that we offer a
            complete money-back guarantee. Try it risk-free for 14 days.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {guaranteeFeatures.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="bg-red-100 p-4 rounded-lg w-fit mx-auto mb-4">
                  <IconComponent className="h-8 w-8 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-black mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MoneyBackGuarantee;
